module.exports = __webpack_public_path__ + "img/info_sp_18.ef362f38.png";